<app-activity-introduction *ngIf="page=='introduction'" [practiceMetaId]="practiceMetaId" (onApply)="onApply()"></app-activity-introduction>
<app-activity-form *ngIf="page=='form'" (onSuccess)="onSuccess()"></app-activity-form>
<app-activity-success *ngIf="page=='success'"></app-activity-success>



// WEBPACK FOOTER //
// ./src/app/activity.component.html